'use strict';

var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');
var MenuApi = require('../api/menuApi');

var MenuAction = {
  /**
   * Get menu
   */
  getMenu: function (module) {
    MenuApi.getMenu(module)
      .then(function (result) {
        Dispatcher.dispatch({
          actionType: ActionType.MENU_GET_MENU,
          menu: result,
          module: module
        })
      });
  },

  cleanMenu: function (module) {
    setTimeout(function () {
      Dispatcher.dispatch({
        actionType: ActionType.MENU_GET_MENU,
        menu: [],
        module: null
      })
    });
  },


  activateItem: function (item) {

    Dispatcher.dispatch({
      actionType: ActionType.MENU_ACTIVATE_ITEM,
      item: item
    })
  }
};

module.exports = MenuAction;
